import React, { useEffect, useState } from "react";
import Dialog from "@mui/material/Dialog";
import { Typography} from "antd";
import * as XLSX from 'xlsx';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faTimesCircle } from '@fortawesome/free-regular-svg-icons';  
import { list } from "../../../controllers/V1/pullOutRequestController";
import moment from "moment";
import Loading from "../../../components/Loading/LoadingEffect";
import { Link } from "react-router-dom";
import UserSelectWithSearch from "../../../components/UserSelectWithSearch";
const VendorListDeletePopUp = ({ popUpOpen, togglePopUp }) => {
  const handleCancel = () =>  togglePopUp();
  const [bind_person_id, setBindPersonId] = useState([]);
  const [isLoading, setIsLoading] = useState(false);
  
  const handleExport = async (e) => {
    e.preventDefault(0);
    try {
      setIsLoading(true);
      const formData = new FormData(e.target);

      const fromDate = formData.get('from_date');
      const toDate = formData.get('to_date');
      
      // Build date condition
      let dateCondition = {};
      if (fromDate && toDate) {
        dateCondition.createdAt = {
          $gte: new Date(`${fromDate} 00:00:00`),
          $lte: new Date(`${toDate} 23:59:59`)
        };
      } else if (fromDate) {
        dateCondition.createdAt = {
          $gte: new Date(`${fromDate} 00:00:00`)
        };
      } else if (toDate) {
        dateCondition.createdAt = {
          $lte: new Date(`${toDate} 23:59:59`)
        };
      }

      const option = {
        condition : { 
          ...dateCondition,
          ...((bind_person_id && bind_person_id?.length > 0) && { bind_person_id : bind_person_id }),
          ...(formData.get('pos_number') && {pos_number : parseInt(formData.get('pos_number')) }),
          ...(formData.get('store_name') && {store_name : { $regex: formData.get('store_name'), $options: "i" } }),
          ...(formData.get('mobile') && {mobile : parseInt(formData.get('mobile')) }),
          ...(formData.get('contact_no') && {contact_no : formData.get('contact_no') }),
          ...(formData.get('collection_received') && {collection_received : formData.get('collection_received') }),
          ...(formData.get('pos_condition') && {pos_condition : { $regex: formData.get('pos_condition'), $options: "i" } }),
          ...(formData.get('status') && {status : formData.get('status') }),
         }
      }
      
      const res = await list(option);
      if(res.status === true){
        let modifiedData = res?.result.map((items, index) => ({
          "Sl. No"                  : index + 1,
          "Customer's Details"      : items?.users_id?.users_name + " " + items?.users_id?.last_name,
          "Bind With"               : items?.bind_person_id?.users_name,
          "Contact No."             : items?.contact_no,
          "Collection Received"     : items?.collection_received === "Y" ? "Yes" : "No",
          "POS Number"              : items?.users_id?.pos_number,
          "POS Condition"           : items?.pos_condition,
          "Device Serial Number"    : items?.users_id?.pos_device_id || "N/A",
          "Status"                  : items?.status,
          "Remarks"                 : items?.remarks || "N/A",
          "Created At"              : moment(items?.createdAt).format('DD-MM-YYYY HH:mm')
        }));
        if(modifiedData?.length > 0){
          await exportToExcel(modifiedData);
        }
        handleCancel();
      }else{
        setIsLoading(false);
      }
    } catch (error) {
      setIsLoading(false);
    }
  }

  const exportToExcel = async (data) => {
    try {
      const workbook = XLSX.utils.book_new();
      const worksheet1 = XLSX.utils.json_to_sheet(data);

      XLSX.utils.book_append_sheet(workbook, worksheet1, "Request list");
      XLSX.writeFile(workbook, `Request List ${moment().format('YYYY-MM-DD')}.xlsx`);
    } catch (error) {
      alert(JSON.stringify(error));
    } finally {
      setIsLoading(false);
    }

  };

  const handleBindWith = (value) => {
    try {
      setBindPersonId(value);
    } catch (error) {
      
    }
  }
  
  return (
    <Dialog
      open={popUpOpen}
      onClose={handleCancel}
      fullWidth={true}
      maxWidth={"md"}
      PaperProps={{
        className: "myDialogPopUp",
      }}
    >
      <div className="myDrawer">
        
        <div className="myDrawer">
          <div className="inventory_popup_title">
            <Typography
              variant="h5"
              component="div"
              gutterBottom
              className="inventory_popup_title_heading"
            >
              Export Request List
            </Typography>
            <Link to={false} style={{ position: "absolute", right: 8, top: 8, color: "#dd5151" }} onClick={handleCancel}><FontAwesomeIcon icon={faTimesCircle}/></Link>
          </div>

          <Typography
            variant="body1"
            component="div"
            className="my_delete_popup_paragraph"
          >
          </Typography>
         
          <Typography
            variant="body1"
            component="div"
            className="my_delete_popup_paragraph"
          >
            <div className="container-fluid">
              <div className="categories_open_popup_main_contnet">
                <form onSubmit={handleExport}>
                  <div className="form-group row">
                    <div className="col-lg-12 col-md-12 col-sm-12 col-xs-12">
                      <label htmlFor="select_bind_with" className="all_section_for_label_main_class" >
                        Select Bind With :
                      </label>
                      <UserSelectWithSearch
                        value={bind_person_id}
                        onChange={(value) => handleBindWith(value)}
                        placeholder="Select bind with users"
                        className="form-control store_input_field"
                        style={{ width: '100%' }}
                        disableOptions={false}
                      />
                    </div>
                    <div className="col-lg-12 col-md-12 col-sm-12 col-xs-12">
                      <label for="store_name" className="all_lable_for_vendor_dashbaord" > Store Name : </label>
                      <input type="text" name="store_name" id="store_name" placeholder="Enter store name" class="form-control categories_select_tg_enter_product" />
                    </div>

                    <div className="col-lg-6 col-md-6 col-sm-12 col-xs-12">
                      <label for="mobile" className="all_lable_for_vendor_dashbaord" > Mobile Number : </label>
                      <input type="number" name="mobile" id="mobile" placeholder="Enter mobile number" className="form-control categories_select_tg_enter_product" />
                    </div>

                    <div className="col-lg-6 col-md-6 col-sm-12 col-xs-12">
                      <label for="pos_number" className="all_lable_for_vendor_dashbaord" > POS Number : </label>
                      <input type="number" name="pos_number" id="pos_number" placeholder="Enter POS number" className="form-control categories_select_tg_enter_product" />
                    </div>

                    <div className="col-lg-6 col-md-6 col-sm-12 col-xs-12">
                      <label for="contact_no" className="all_lable_for_vendor_dashbaord" > Contact Number : </label>
                      <input type="number" name="contact_no" id="contact_no" placeholder="Enter contact number" className="form-control categories_select_tg_enter_product" />
                    </div>

                    <div className="col-lg-6 col-md-6 col-sm-12 col-xs-12">
                      <label for="pos_condition" className="all_lable_for_vendor_dashbaord" > POS Condition : </label>
                      <input type="text" name="pos_condition" id="pos_condition" placeholder="Enter POS Condition" className="form-control categories_select_tg_enter_product" />
                    </div>

                    <div className="col-lg-6 col-md-6 col-sm-12 col-xs-12">
                      <label for="collection_received" className="all_lable_for_vendor_dashbaord" > Collection Received : </label>
                      <select name="collection_received" id="collection_received" className="form-control categories_select_tg_enter_product">
                        <option value={""}>Select Collection Received</option>
                        <option value={"Y"}>Yes</option>
                        <option value={"N"}>No</option>
                      </select>
                    </div>

                    <div className="col-lg-6 col-md-6 col-sm-12 col-xs-12">
                      <label for="status" className="all_lable_for_vendor_dashbaord" > Status : </label>
                      <select name="status" id="status" className="form-control categories_select_tg_enter_product">
                        <option value={""}>Select status</option>
                        <option value={"Pending"}>Pending</option>
                        <option value={"Completed"}>Completed</option>
                        <option value={"Reject"}>Reject</option>
                      </select>
                    </div>
                    

                    <div className="col-lg-6 col-md-6 col-sm-12 col-xs-12">
                      <label for="from_date" className="all_lable_for_vendor_dashbaord" > From Date : <span style={{color: 'red'}}>*</span></label>
                      <input type="date" name="from_date" id="from_date" required class="form-control categories_select_tg_enter_product" />
                    </div>

                    <div className="col-lg-6 col-md-6 col-sm-12 col-xs-12">
                      <label for="to_date" className="all_lable_for_vendor_dashbaord" > To Date : <span style={{color: 'red'}}>*</span></label>
                      <input type="date" name="to_date" id="to_date" required class="form-control categories_select_tg_enter_product" />
                    </div>

                    <div className="col-lg-12 col-md-12 col-sm-12 col-xs-12">
                      <div className="inventory_open_popup_action_btn">
                        <button type="button" className="btn btn-light categories_cancel_button" onClick={handleCancel} > Cancel </button>
                        <button type="submit" className="btn btn-danger" > Download Excel </button>
                      </div>
                    </div>
                  </div>
                </form>
              </div>
            </div>
          </Typography>
        </div>
      </div>
      <Loading isLoading={isLoading} text={`Preparing download...`} />
    </Dialog>
  );
};

export default VendorListDeletePopUp;
